import { render, staticRenderFns } from "./CourseStatisticUsersTable.vue?vue&type=template&id=511bbd81&"
import script from "./CourseStatisticUsersTable.vue?vue&type=script&lang=js&"
export * from "./CourseStatisticUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports